var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"world-background"},[_c('cards-roulette',{attrs:{"options":_vm.options,"type":'ebidta_amount_ranges',"withImages":false,"numerated":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }